(function () {
  class WinlineDisplay extends PIXI.Container {
    constructor() {
      super();

      messageBus.subscribe('spinner:GameConfigEvent', this.onGameConfigEvent.bind(this));
      Reflex.registerEventHandler('layoutChange', this.onLayoutChange.bind(this));
      Reflex.addToUpdate(this.update.bind(this));
    }

    initialise() {
      this._jsonPath = this.name + ':winlineContainer:winlineParticleContainer';
      this._winlineParticleContainer = undefined;
      this._winlineEmitter = undefined;
      this._winlineData = undefined;
      this._winlineAnimation = undefined;
      // Positions should be centred, not sure why they're not. Will need to investigate
      this._xShift = -5;
      this._yShift = -40;
      // How much to shift the winline from the first position to start at the left reel frame
      this._xStart = 83;
      // How much to shift the winline from the last position to start at the right reel frame
      this._xEnd = 83;

      this._presentWinlineDuration = 0.3;
      this._cycleWinlineDuration = 0.5;
    }

    update(delta, time) {}

    onGameConfigEvent(task) {
      this._winlineParticleContainer = resourceManager.get(this._jsonPath);

      this._winlineData = task.data.slotConfig.paylines;
      this._winlineEmitter = particleManager.createEmitter(
        'winline',
        this._jsonPath,
        this._xShift,
        this._yShift,
        false
      );
      this._winlineEmitter.particleEmitter.blendMode = PIXI.BLEND_MODES.ADD;
      this._winlineEmitter.particleEmitter.emit = false;
      this._winlineEmitter.visible = true;
    }

    animateWinline(winlineID, direction, winAmount, megawildMulti, megawildOnReel3, isCycle = false) {
      let positions = [];
      const winlineIndex = winlineID - 1;
      const isRightToLeft = direction === -1;

      if (megawildMulti !== -1) {
        winAmount /= megawildMulti;
      }

      for (let i = 0; i < this._winlineData[winlineIndex].spots.length; i++) {
        const index = isRightToLeft ? this._winlineData[winlineIndex].spots.length - 1 - i : i;
        const row = this._winlineData[winlineIndex].spots[index];
        const pos = helpers.getSymbolPos(index, row);
        positions.push(pos);
      }

      let xStart = this._xStart;
      let xEnd = this._xEnd;
      if (isRightToLeft) {
        xStart = -xStart;
        xEnd = -xEnd;
      }

      const lastPos = {
        x: positions[positions.length - 1].x + xEnd,
        y: positions[positions.length - 1].y,
      };
      positions.push(lastPos);

      const emitterSpawnPos = {
        x: positions[0].x - xStart,
        y: positions[0].y,
      };

      this._winlineParticleContainer.x = emitterSpawnPos.x;
      this._winlineParticleContainer.y = emitterSpawnPos.y;

      const distance = (p1, p2) => Math.hypot(p2.x - p1.x, p2.y - p1.y);
      const distances = positions.slice(0, -1).map((p, i) => distance(p, positions[i + 1]));
      const totalDistance = distances.reduce((a, b) => a + b, 0);

      this._winlineAnimation = gsap.timeline({
        defaults: {
          ease: 'linear',
        },
        onStart: () => {
          this._winlineEmitter.particleEmitter.emit = true;
        },
        onComplete: () => {
          this._winlineEmitter.particleEmitter.emit = false;
        },
      });

      const duration = isCycle ? this._cycleWinlineDuration : this._presentWinlineDuration;
      let textDuration = duration;

      if (megawildMulti !== -1) {
        textDuration += 0.9;
      }

      if (positions.length >= 3) {
        const textRow = this._winlineData[winlineIndex].spots[2];
        gameData.winningsText.displayWinline(winAmount, 2, textRow, textDuration, megawildMulti, megawildOnReel3);
      }

      const lineDurations = [];

      distances.forEach((dist, i) => {
        const lineDuration = (dist / totalDistance) * duration;
        lineDurations.push(lineDuration);
        this._winlineAnimation.to(emitterSpawnPos, {
          x: positions[i + 1].x,
          y: positions[i + 1].y,
          duration: lineDuration,
          onUpdate: () => {
            this._winlineParticleContainer.x = emitterSpawnPos.x;
            this._winlineParticleContainer.y = emitterSpawnPos.y;
          },
        });
      });

      return lineDurations;
    }

    cancelWinlines() {
      if (this._winlineAnimation) {
        this._winlineAnimation.kill();
        this._winlineAnimation = undefined;
        this._winlineEmitter.particleEmitter.emit = false;
      }
    }

    onLayoutChange() {}
  }

  let creator = function (json) {
    return new WinlineDisplay();
  };

  let filesRequired = function () {
    return [];
  };

  resourceManager.registerObjectType('winlineDisplay', creator, initialise, filesRequired);
})();
